import request from '@/utils/request2'

// 列表(主数据列表)
export function loadContractServiceItemListDataApi(data) {
  return request({
    url: 'tms-web/contractServiceItem/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportContractServiceItemListDataApi(data) {
  return request({
    url: 'tms-web/contractServiceItem/exportByPage',
    method: 'post',
    data
  })
}

// 保存
export function saveContractServiceItemApi(data) {
  return request({
    url: 'tms-web/contractServiceItem/save',
    method: 'post',
    data
  })
}

// 作废
export function deleteContractServiceItemApi(data) {
  return request({
    url: 'tms-web/contractServiceItem/delete',
    method: 'post',
    data
  })
}

// 查看
export function viewContractServiceItemApi(data) {
  return request({
    url: 'tms-web/contractServiceItem/view',
    method: 'post',
    data
  })
}

// 列表
export function listContractServiceItemApi(data) {
  return request({
    url: 'tms-web/contractServiceItem/list',
    method: 'post',
    data
  })
}
